import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class PersonneMoraleDirectorModificationList extends ShadowDOMElement {
	static className = "PersonneMoraleDirectorModificationList";
	
	static properties = {
		title: {type: String, attribute: "title" },
		showReplacement: { type: Boolean, attribute: "show-replacement",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.managers = [];
		this.title = "Administrateur";
	}

	firstUpdated() {
		super.firstUpdated();
		this.addManager();
	}

	addManager() {
		const managerContainer = document.createElement("personne-morale-director-modification");
		managerContainer.setAttribute("show-replacement", this.showReplacement);

		if (this.managers.length > 0) {
			const deleteButtonWrapper = this.createDeleteButton(managerContainer);
			this.appendChild (deleteButtonWrapper);
		}

		this.managers.push(managerContainer);
		this.appendChild (managerContainer);
	}

	removeManager(managerContainer, deleteButtonWrapper) {
		this.managers = this.managers.filter((manager) => manager !== managerContainer);
		this.removeChild(managerContainer);
		if (deleteButtonWrapper)
			this.removeChild(deleteButtonWrapper);
	}

	createDeleteButton(managerContainer) {
		const deleteButtonWrapper = document.createElement("row-wrapper");
		const deleteButton = document.createElement("button-field");

		deleteButton.onClickHandler = () => {
			this.removeManager(managerContainer, deleteButtonWrapper);
		};

		deleteButton.innerHTML = `<i class="fa fa-minus"></i><span>&nbsp;Supprimer</span>`;
		deleteButtonWrapper.appendChild(deleteButton);

		return deleteButtonWrapper;
	}

	render() {
		return html`
		<row-wrapper>
			<subtitle-field label="${this.title}"></subtitle-field>
		</row-wrapper>
		<slot></slot>
		<row-wrapper data-add-button="true">
			<button-field .onClickHandler="${this.addManager.bind(this)}">
				<i class="fa fa-plus"></i><span>&nbsp;Ajouter une personne morale</span>
			</button-field>
		</row-wrapper>
	    `;
	}
	
	isTransient (){
		return false;
	}

	getValues (){
		return {
			"count" : this.managers.length || 1,
			... super.getValues ()
		}
	}

	setValues (values){
		while (this.managers.length < values.count)
	        this.addManager ();
		super.setValues (values);
	}
}

customElements.define("personne-morale-director-modification-list", PersonneMoraleDirectorModificationList);
